export default __webpack_public_path__ + "static/apparel-website-3c47d3f7d983ef6e91b72f0b9a9f0d76.png";